import {UIComponent} from "@/engine/UI/UIComponent.js";

export class UICMapList extends UIComponent {
    constructor(options) {
        let defOptions = {
            id: 'mapList',
            view: 'mapsList',
            controlsView: 'mapControls',
            title: 'Map list',
            // the list of map items
            list: [],
            // cb function that is called to retrieve an actual items list
            // is called on open and events, optional
            listBuilder: null,
            // returns an empty content if contentData is null or empty
            emptyIfNoContentData: true,
            // cb function that adds additional
            // properties to the list item object, optional
            itemOptionsBuilder: null,
            // item UI actions callbacks list, if empty or doesn't have
            // the action key, the defaultAction is called on the action
            actions: {},
            // element lookup attribute, optional
            elementLookupAttributeName: "action", // element action attribute
            // event object, is used to read or send events
            eventObject: null,
            // event prefix name
            eventNamePrefix: "",
            // allow items reordering using drag & drop
            draggable: false,
            // calls when items was reordered by drag operation
            reorderCb: null,
            // action controls default handler, is called on clicks on action elements
            defaultAction: function (action, item) {
                // fire an action event on the object
                if ( ! this.eventObject || ! this.eventObject.fire) {
                    console.log(`UI action ${action} in ${item.id}, but there is no handler for this action`)
                    return
                }
                this.eventObject.fire(`${this.eventNamePrefix}:ui:action:${action}`, {data: item})
            }
        }
        super(Object.assign(defOptions, options), null);

        this.dragEl = null
        this.dragOverEl = null
        // creates a data object with data filled into the view
        this.contentData = function () {
            let list = []
            if (this.list.length === 0)
                return {}

            // add additional options from itemOptionsBuilder
            for (let i of this.list) {
                let m = Object.assign({}, i)
                if (this.itemOptionsBuilder && typeof this.itemOptionsBuilder === "function") {
                    let o = this.itemOptionsBuilder(i)
                    o.areaListItemId = `${i.id}-${this.id}-list-item`
                    for (let e in o) {
                        m[e] = o[e]
                    }
                }
                if (this.draggable)
                    m.draggable = true
                list.push(m)
            }
            return [{mapList: list}, {controls: this.template(this.controlsView)}]
        }.bind(this)
    }

    // add action handlers when content is ready
    onContentReady(container) {
        if (!container)
            return
        for (let i of this.list) {
            // add action handlers
            let c
            try {
                c = container.querySelector(`#${i.id}-${this.id}-list-item`)
            } catch {

            }
            if (!c)
                continue
            let actionElements = c.querySelectorAll(`[${this.elementLookupAttributeName}]`)
            for (let el of actionElements) {
                if (! el.onclick) // this prevents to rewrite handler on nested controls
                    el.onclick = function () {
                        let action = el.getAttribute(this.elementLookupAttributeName)
                        if (! action)
                            return
                        if (this.actions && this.actions[action]) {
                            this.actions[action](i)
                        } else if (this.defaultAction && typeof this.defaultAction === "function") {
                            this.defaultAction(action, i)
                        }
                    }.bind(this)
            }
        }

        // add drag handlers
        if (this.draggable) {
            let elms = container.querySelectorAll('.area-list > .area-list-item');
            elms.forEach( el => { this.addDragHandlers(el)});
        }
    }

    // performs UI update only if list is changed
    updateList(list) {
        if (! list && this.listBuilder && typeof this.listBuilder === "function")
            list = this.listBuilder()

        if (!list)
            return false

        let changed = list.length !== this.list.length

        if (! changed) {
            for (let l of list) {
                let f = false
                for (let lo of this.list) {
                    if (lo === l) {
                        f = true
                        break
                    }
                }
                if (!f) {
                    changed = true
                    break
                }
            }
        }

        if (changed) {
            // clear the layer and fill with new elements
            // we don't use 'this.list = list' because the pointer to this.list
            // could be used somewhere else
            this.list.splice(0, this.list.length);
            this.list.push(...list)
            this.updateContent()
        }
        return changed
    }

    open(container, parent, data, templateIncludes) {
        super.open(container, parent, data, templateIncludes)
        if (this.eventObject) {
            this.eventObject.
            on(`${this.eventNamePrefix}:visiblechanged`, this.evItemChanged, this).
            on(`${this.eventNamePrefix}:updateProperties`, this.evItemChanged, this).
            on(`${this.eventNamePrefix}:remove`, this.evItemAddRemove, this).
            on(`${this.eventNamePrefix}:add`, this.evItemAddRemove, this)
        }
        this.updateList()
    }

    close(onCancel) {
        super.close(onCancel)
        if (this.eventObject) {
            this.eventObject.
            off(`${this.eventNamePrefix}:visiblechanged`, this.evItemChanged, this).
            off(`${this.eventNamePrefix}:updateProperties`, this.evItemChanged, this).
            off(`${this.eventNamePrefix}:remove`, this.evItemAddRemove, this).
            off(`${this.eventNamePrefix}:add`, this.evItemAddRemove, this)

        }
    }

    evItemChanged(ev) {
        let i = this._lookupEventedObject(ev)
        if (!i)
            return

        if (this.debug) {
            console.log(`${this.id}: got item updating event from ${i.id}`)
        }
        this.updateContent()
    }

    evItemAddRemove(ev) {
        let i = this._eventedObject(ev)
        if (!i)
            return
        if (this.debug)
            console.log(`${this.id}: got add/remove event of ${i.id}`)

        this.updateList()
    }

    _lookupEventedObject(ev) {
        let i = this._eventedObject(ev)
        if (!i)
            return null

        for (let item of this.list) {
            if (item === i) {
                return item
            }
        }
        return null
    }

    _eventedObject(ev) {
        if (!ev)
            return null
        let i = ev.layer

        if (!i)
            i = ev.workspace

        return i
    }

    dragStart(e) {
        this.dragEl = e.target;
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', this.outerHTML);
        //this.classList.add('dragging');
    }

    dragEnd() {
        this._removeDragOver()
    }
    dragOver(e) {
        if (e.preventDefault) {
            e.preventDefault();
        }
        e.dataTransfer.dropEffect = 'move';
        return false;
    }

    dragEnter(e) {
        let target = this._findDragTarget(e.target, this.dragEl.parent)
        if (!target) {
            this._removeDragOver()
            return
        }
        if ( this.dragOverEl && target !== this.dragOverEl) {
            this._removeDragOver()
            this.dragOverEl = target
        }
        //console.log(`set drag-over at ${target.id}`)
        target.classList.add('drag-over');
        this.dragOverEl = target
    }

    dragLeave(e) {
        let target = this._findDragTarget(e.target, this.dragEl.parent)
        if (!target) {
            this._removeDragOver()
        }
    }

    dragDrop(e) {
        if (e.stopPropagation) {
            e.stopPropagation(); // stops the browser from redirecting.
        }

        this._removeDragOver()

        let target = this._findDragTarget(e.target, this.dragEl.parent)
        if (!target) {
            this.dragEl = null
            return false
        }
        if (this.dragEl !== target) {
            let parent = target.parentNode
            let sPos = this._findChildPos(this.dragEl)
            let tPos = this._findChildPos(target)
            if (this.debug)
                console.log(`moving the element from ${sPos} to ${tPos}`)
            if (target.previousElementSibling === this.dragEl) {
                // swap two sibling elements
                parent.insertBefore(target, this.dragEl)
            } else {
                if (sPos < tPos) {
                    // move down
                    // insert after target element
                    if (target.nextElementSibling) {
                        parent.insertBefore(this.dragEl, target.nextElementSibling)
                    } else {
                        parent.append(this.dragEl)
                    }
                } else {
                    // move up
                    parent.insertBefore(this.dragEl, target)
                }
                // insert before target element
            }
            // reorder an object item in this.list
            this._reorderItem(sPos, tPos)
            if (this.reorderCb && typeof this.reorderCb === "function") {
                this.reorderCb(this.list, sPos, tPos)
            }
        }
        return true
    }

    _findDragTarget(element, stopOn) {
        let el = element;
        while (el) {
            if (el === stopOn) {
                return null
            }
            if (el.getAttribute('draggable') === "true") {
                return el;
            }
            el = el.parentElement;
        }
        return null;
    }

    _findChildPos(element) {
        const children = Array.from(element.parentElement.children)
        return children.indexOf(element);
    }

    _removeDragOver() {
        if ( this.dragOverEl) {
            //console.log(`remove drag-over from ${this.dragOverEl.id}`)
            this.dragOverEl.classList.remove('drag-over');
            this.dragOverEl = null
        }
    }

    _reorderItem(fromIdx, toIdx) {
        if (fromIdx < 0 ||
            fromIdx >= this.list.length ||
            toIdx < 0 ||
            toIdx >= this.list.length ||
            fromIdx === toIdx) {
            return
        }

        // extract the element
        const elementToMove = this.list.splice(fromIdx, 1)[0];

        // put the element to the new position
        this.list.splice(toIdx, 0, elementToMove);
    }

    addDragHandlers(elem) {
        elem.addEventListener('dragstart', this.dragStart.bind(this));
        elem.addEventListener('dragenter', this.dragEnter.bind(this));
        elem.addEventListener('dragover', this.dragOver.bind(this));
        elem.addEventListener('dragleave', this.dragLeave.bind(this));
        elem.addEventListener('drop', this.dragDrop.bind(this));
        elem.addEventListener('dragend', this.dragEnd.bind(this));
    }
}
